// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1jmcC","title":"ClientReferral_title__2h8AZ","itemText":"ClientReferral_itemText__2Je-M"};